export default {
  computed: {
    isLoading () {
      const prog = this.$Progress.get()
      return prog !== 100 && prog !== 0
    }
  }
}
